import { motion } from "framer-motion";

const NAME = "ZIMMEREI MÜLLER".split("");

export const Loader = () => (
  <motion.div
    data-testid="loading-screen"
    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white"
    exit={{ opacity: 0, transition: { duration: 0.6, ease: "easeInOut" } }}
  >
    <svg width="150" height="90" viewBox="0 0 150 90" fill="none">
      <motion.path
        d="M12 14 H58 L12 76 H58"
        stroke="#2A5C2A" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round"
        initial={{ pathLength: 0 }} animate={{ pathLength: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      />
      <motion.path
        d="M76 76 V14 L104 52 L132 14 V76"
        stroke="#2A5C2A" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round"
        initial={{ pathLength: 0 }} animate={{ pathLength: 1 }}
        transition={{ duration: 1.2, ease: "easeOut", delay: 0.15 }}
      />
    </svg>
    <div className="mt-6 flex" aria-label="Zimmerei Müller">
      {NAME.map((ch, i) => (
        <motion.span
          key={i}
          className="font-heading text-2xl sm:text-3xl font-bold tracking-[0.2em] text-[#2A5C2A]"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 + i * 0.045, duration: 0.35 }}
        >
          {ch === " " ? "\u00A0" : ch}
        </motion.span>
      ))}
    </div>
    <motion.p
      className="mt-3 text-sm tracking-[0.3em] text-[#666666]"
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.0, duration: 0.4 }}
    >
      ZEITLOFS · SPESSART · BAYERN
    </motion.p>
  </motion.div>
);
